document.addEventListener('DOMContentLoaded', function () {
  const DELAY_MS = 3000;
  const HIDE_DAYS = 30;

  document.querySelectorAll('[data-sticky-banner]').forEach(function (banner) {
    const dismissible = banner.hasAttribute('data-dismissible');
    const storageKey = 'sticky-banner-dismissed-' + banner.id;
    const dismissedUntil = localStorage.getItem(storageKey);

    if (dismissible && dismissedUntil && Date.now() < Number(dismissedUntil)) {
      return;
    }

    const showTimer = setTimeout(function () {
      banner.classList.remove('is-hidden');
    }, DELAY_MS);

    function dismissBanner() {
      clearTimeout(showTimer);
      banner.classList.add('is-hidden');
      const expiry = Date.now() + HIDE_DAYS * 24 * 60 * 60 * 1000;
      localStorage.setItem(storageKey, String(expiry));
    }

    const closeButton = banner.querySelector('[data-sticky-banner-close]');
    if (closeButton) {
      closeButton.addEventListener('click', dismissBanner);
    }

    const ctaButton = banner.querySelector('.sticky-banner__button');
    if (ctaButton) {
      ctaButton.addEventListener('click', dismissBanner);
    }
  });
});